import { render, staticRenderFns } from "./WorkspaceRightSidebar.vue?vue&type=template&id=0db4ee78&scoped=true"
import script from "./WorkspaceRightSidebar.vue?vue&type=script&lang=js"
export * from "./WorkspaceRightSidebar.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceRightSidebar.vue?vue&type=style&index=0&id=0db4ee78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4ee78",
  null
  
)

export default component.exports